export function updateDropzoneOptions(options, vueDropzone) {
    if (vueDropzone) {
        vueDropzone.setOption('maxFilesize', options.maxFilesize);
        vueDropzone.setOption('parallelUploads', options.parallelUploads);
        vueDropzone.setOption('maxFiles', options.maxFiles);
    }
}
